import { connect } from "react-redux";
import LayoutsView from "../../../components/layoutsView/LayoutsView";
import { getAvailableStores, getAvailableFloors, getGlobalLayers, getLinearTypes, getLayoutVersions, getStoreMapLayout, getStoreLayout, postStoreLayout } from "core/slices/layouts";
import { getMapMetadataFile } from "core/slices/mapMetadataFile";
import { setSnackAlert } from "core/slices/snackAlert";
import {
    isLoadingAvailableStores,
    getLocalAvailableStores,
    getLocalAvailableFloors,
    isLoadingAvailableFloors,
    getLocalGlobalLayers,
    isLoadingGlobalLayers,
    linearTypes,
    linearTypeParams,
    isLoadingLinearTypes,
    isLoadingLayoutVersions,
    isLoadingStoreMapLayout,
    getLocalStoreMapLayout,
    getLocalStoreLayout,
    isLoadingStoreLayout,
    getLocalSendStoreLayout,
    isLoadingSendStoreLayout,
    getMapMetadataURL,
    isLoadingMapMetadataURL,
} from 'core/selectors';

export default connect((state) => ({
    availableStores: getLocalAvailableStores(state),
    isLoadingAvailableStores: isLoadingAvailableStores(state),
    availableFloors: getLocalAvailableFloors(state),
    isLoadingAvailableFloors: isLoadingAvailableFloors(state),
    globalLayers: getLocalGlobalLayers(state),
    isLoadingGlobalLayers: isLoadingGlobalLayers(state),
    linearTypes: linearTypes(state),
    linearTypeParams: linearTypeParams(state),
    isLoadingLinearTypes: isLoadingLinearTypes(state),
    isLoadingVersions: isLoadingLayoutVersions(state),
    isLoadingStoreMapLayout: isLoadingStoreMapLayout(state),
    storeMapLayout: getLocalStoreMapLayout(state),
    storeLayout: getLocalStoreLayout(state),
    isLoadingStoreLayout: isLoadingStoreLayout(state),
    sendLayoutStore: getLocalSendStoreLayout(state),
    isLoadingSendStoreLayout: isLoadingSendStoreLayout(state),
    mapMetadataURL: getMapMetadataURL(state),
    isLoadingMapMetadataURL: isLoadingMapMetadataURL(state),
}), {
    getAvailableStores,
    getAvailableFloors,
    getGlobalLayers,
    getLinearTypes,
    getLayoutVersions,
    getStoreMapLayout,
    getStoreLayout,
    postStoreLayout,
    setSnackAlert,
    getMapMetadataFile
})(LayoutsView);
